/* eslint-disable no-unused-vars */
import React, { useEffect, Fragment, useState, useRef } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap'

import { ReactComponent as PhoneCallIcon } from '../../assets/icons/phone-call.svg'
import { ReactComponent as IncomingCallIcon } from '../../assets/icons/incoming-call.svg'
import { ReactComponent as EmailIcon } from '../../assets/icons/email.svg'
import { ReactComponent as DirectMailIcon } from '../../assets/icons/direct_mail.svg'
import { ReactComponent as MeetingIcon } from '../../assets/icons/meeting.svg'
import { ReactComponent as TextMessageIcon } from '../../assets/icons/text_message.svg'
import { ReactComponent as SharedNoteIcon } from '../../assets/icons/shared_note.svg'
import { getTimelineData } from '../../common/ContactCommonComponents/ActivitiesTimeline/redux/activitiesTimelineActions'
import CustomModal from '../../common/CustomModal/CustomModal'
import { formatDateWithTimezone } from '../../utils/utcTime'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
  DIRECT_MAIL,
  EMAIL,
  INCOMING_CALL,
  MEETING,
  OUT_GOING_CALL,
  SHARED_NOTE,
  TEXT_MESSAGE,
} from '../../constants/activityTypes'
import './index.scss'

const ActivitiesTimeline = ({ activities, divisions, contactId, getTimelineData, query }) => {
  const [filterValues, setFilterValues] = useState({
    allActivities: true,
    myActivities: false,
    myTeamActivities: false,
    division: [],
    activityType: [],
  })

  const [selectValues, setSelectValues] = useState({
    divisionOptions: [],
    activityTypeOptions: [],
  })
  const [modalSeeFullNotes, setModalSeeFullNotes] = useState({
    isOpen: false,
    notes: '',
  })
  const noteRef = useRef(null)

  useEffect(() => {
    if (filterValues.division.length === 0 && !filterValues.myActivities && !filterValues.myTeamActivities) {
      setFilterValues({ ...filterValues, allActivities: true })
    }
  }, [filterValues.myActivities, filterValues.myTeamActivities, filterValues.division])

  useEffect(() => {
    loadData()
    loadSelectValues()
  }, [])

  const loadData = () => {
    let filter = {
      allActivities: filterValues.allActivities,
      myActivities: filterValues.myActivities,
      myTeamActivities: filterValues.myTeamActivities,
      division: filterValues.division.length > 0 && filterValues.division,
      activityType: filterValues.activityType.length > 0 && filterValues.activityType,
      contactId,
    }
    getTimelineData(filter, { first: 0, limit: query.limit }, true)
  }

  const fetchMore = () => {
    let filter = {
      allActivities: filterValues.allActivities,
      myActivities: filterValues.myActivities,
      myTeamActivities: filterValues.myTeamActivities,
      division: filterValues.division.length > 0 && filterValues.division,
      activityType: filterValues.activityType.length > 0 && filterValues.activityType,
      contactId,
    }
    getTimelineData(filter, { first: query.first + query.limit, limit: query.limit }, false)
  }

  const loadSelectValues = async () => {
    const divisionOptions = [],
      activityTypeOptions = []
    divisions &&
      divisions.forEach((division) =>
        divisionOptions.push({
          label: division.name,
          value: division.id,
        })
      )

    const responseActivityType = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: 8 } },
    })
    responseActivityType.data.data.forEach((activity) =>
      activityTypeOptions.push({
        label: activity.name,
        value: activity.id,
      })
    )

    setSelectValues({ divisionOptions, activityTypeOptions })
  }

  const onChangeSwitches = (e) => {
    const { name, value } = e.target
    setFilterValues({
      ...filterValues,
      allActivities: false,
      myActivities: false,
      myTeamActivities: false,
      division: [],
      [name]: value,
    })
  }

  const onChangeSelect = (value, e) => {
    const { name } = e
    const newSelectedValue = []
    if (value) {
      value.forEach((value) => {
        newSelectedValue.push(value.value)
      })
      if (name === 'division') {
        setFilterValues({
          ...filterValues,
          allActivities: false,
          myActivities: false,
          myTeamActivities: false,
          division: [],
          [name]: newSelectedValue,
        })
      } else setFilterValues({ ...filterValues, [name]: newSelectedValue })
    } else {
      setFilterValues({ ...filterValues, [name]: [] })
    }
  }

  const onSearchClick = () => {
    loadData()
  }

  const onSeeFullNotesClick = (notes) => {
    setModalSeeFullNotes({
      isOpen: !modalSeeFullNotes.isOpen,
      notes: notes || '',
    })
  }

  const endMessage = query.totalRecords > 0 && (
    <div className={'mt-2 mb-2 end_container'}>
      <h6 style={{ fontStyle: 'italic' }}>No more activities available!</h6>
    </div>
  )

  const composeIcon = (activity) => {
    let icon = null
    const { id } = activity.activityTypeData
    if (id === OUT_GOING_CALL) icon = <PhoneCallIcon />
    else if (id === INCOMING_CALL) icon = <IncomingCallIcon />
    else if (id === TEXT_MESSAGE) icon = <TextMessageIcon />
    else if (id === EMAIL) icon = <EmailIcon />
    else if (id === MEETING) icon = <MeetingIcon />
    else if (id === DIRECT_MAIL) icon = <DirectMailIcon />
    else if (id === SHARED_NOTE) icon = <SharedNoteIcon />
    return icon
  }

  const composeIconBackgroundColor = (activityType) => {
    switch (activityType) {
      case EMAIL:
      case DIRECT_MAIL:
        return '#ff7450'
      case MEETING:
        return '#4ca3dd'
      case INCOMING_CALL:
        return '#d640d3'
      case OUT_GOING_CALL:
        return '#522888'
      case TEXT_MESSAGE:
        return 'goldenrod'
      case SHARED_NOTE:
        return 'green'
      default:
        return 'grey'
    }
  }

  return (
    <Fragment>
      <CustomModal isOpen={modalSeeFullNotes.isOpen} toggle={onSeeFullNotesClick} headerText={'Full Notes'}>
        <Row>
          <Col>
            <div
              dangerouslySetInnerHTML={{
                __html: modalSeeFullNotes.notes,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button size='sm' color='danger' onClick={onSeeFullNotesClick} className='float-right'>
              Close
            </Button>
          </Col>
        </Row>
      </CustomModal>
      <Row>
        <Col>
          <Card>
            <CardHeader>Timeline</CardHeader>
            <CardBody className='vertical-timeline-custom'>
              <Row>
                <Col>
                  <div id={'scrollableTimelineElement'}>
                    <InfiniteScroll
                      hasMore={query.hasMore}
                      dataLength={activities.length}
                      next={fetchMore}
                      loader={<h6>loading...</h6>}
                      endMessage={endMessage}
                      scrollableTarget='scrollableTimelineElement'
                      scrollThreshold={0.8}
                    >
                      <VerticalTimeline>
                        {Array.isArray(activities) &&
                          activities.map((activity, index) => {
                            return (
                              <VerticalTimelineElement
                                key={activity.id}
                                className='vertical-timeline-element--work'
                                contentArrowStyle={{
                                  background: 'transparent',
                                }}
                                iconStyle={{
                                  background: composeIconBackgroundColor(activity.activityTypeData.id),
                                  color: '#fff',
                                  fill: '#fff',
                                }}
                                icon={composeIcon(activity)}
                              >
                                <h3 className='timeline-subject'>
                                  <span className='timeline-subject__subject'>Subject: </span>
                                  {activity.subject}
                                </h3>
                                <p className='timeline-notes'>
                                  <span className='timeline-notes__headline'>Next Step: </span>
                                  {activity.nextStep}
                                </p>
                                <p className='timeline-notes'>
                                  <span className='timeline-notes__headline'>Notes: </span>
                                  <div
                                    ref={(el) => {
                                      if (el) {
                                        if (el.offsetHeight > 75) {
                                          el.style.height = '75px'
                                          const div = document.createElement('div')
                                          div.classList.add('seeFullNotes')
                                          const button = document.createElement('button')
                                          button.classList.add('button-full-notes')
                                          button.onclick = function () {
                                            return onSeeFullNotesClick(activity.notes)
                                          }
                                          const textButton = document.createTextNode('See full notes')
                                          button.appendChild(textButton)
                                          div.appendChild(button)
                                          el.appendChild(div)
                                        }
                                      }
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: activity.notes,
                                    }}
                                    className='timeline-notes__notes'
                                  />
                                </p>
                                <div
                                  className={`date-name-info ${
                                    index % 2 === 0 ? 'date-name-info__left' : 'date-name-info__right'
                                  }`}
                                >
                                  <span className='date-name-info__name'>
                                    {activity.userName} - {activity.userDivision}
                                  </span>
                                  <span className='date-name-info__date'>
                                    {formatDateWithTimezone(activity.creationDate, 'MM/DD/YYYY hh:mm A')}
                                  </span>
                                  <span className='date-name-info__call mt-2'>
                                    {activity?.callData?.duration && (
                                      <>
                                        CALL DURATION: <span>{activity.callData.duration} SECONDS</span>
                                      </>
                                    )}
                                  </span>
                                </div>
                              </VerticalTimelineElement>
                            )
                          })}
                      </VerticalTimeline>
                    </InfiniteScroll>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  )
}

ActivitiesTimeline.propTypes = {
  activities: PropTypes.object.isRequired,
  divisions: PropTypes.array.isRequired,
  getTimelineData: PropTypes.func.isRequired,
  contactId: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => ({
  activities: state.contactActivitiesTimeline.activitiesTimelineData,
  query: state.contactActivitiesTimeline.query,
})

export default connect(mapStateToProps, { getTimelineData })(ActivitiesTimeline)
